import { tsValidateArray, tsValidateDynamicObject, tsValidateOptionalId, tsValidateRange, tsValidateString, tsValidateUniqueId, tsValidateValue, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { LikelihoodDirections, LikelihoodValues, SeverityValues } from '../../_enum.js';
import { DBDef_Expression, knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    _diseaseProfileId: tsValidateUniqueId,
    multiVarId: tsValidateUniqueId,
    severityFactor: tsValidateValue([...SeverityValues], false),
    indicative: tsValidateValue([-1, 1], false),
    likelihood: tsValidateValue([...LikelihoodValues], false),
    likelihoodNumeric: tsValidator_nonMandatoryString,
    likelihoodRange: tsValidateRange(false),
    likelihoodDirection: tsValidateValue([...LikelihoodDirections], false),
    values: tsValidateDynamicObject(tsValidateString(), tsValidateUniqueId),
    sourceId: tsValidateOptionalId,
    expressionId: tsValidateOptionalId,
};
const Validator_GeneratedProps = {
    _values: tsValidateArray(tsValidateString()),
    _variables: tsValidateArray(tsValidateString()),
};
export const DBDef_DiseaseValue = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.5', '1.0.4', '1.0.3', '1.0.2'],
    dbKey: 'disease-values',
    entityName: 'DiseaseValue',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'disease-value'
    },
    backend: {
        name: 'disease-values'
    },
    dependencies: {
        'multiVarId': {
            dbKey: 'multi-vars',
            fieldType: 'string'
        },
        '_values': {
            dbKey: 'values',
            fieldType: 'string[]'
        },
        '_variables': {
            dbKey: 'variables',
            fieldType: 'string[]'
        },
        '_diseaseProfileId': {
            dbKey: 'disease-profiles',
            fieldType: 'string'
        },
        'expressionId': {
            dbKey: DBDef_Expression.dbKey,
            fieldType: 'string',
        },
        'sourceId': {
            dbKey: 'tags',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map